import { withInstall } from "@xplus/utils/with-install";
import text from "./src/text.vue";
export const xText = withInstall(text);
export default xText;
export * from "./src/text";
